module.exports = __webpack_public_path__ + "img/20200529_142303.b508101c.jpg";